<script setup lang="ts">
import { NotebookPenIcon } from 'lucide-vue-next'

const { data: roundsWithMissingAssignments, isPending } = useRoundsWithMissingAssignments()
const { t } = useI18n()
const router = useRouter()

const handleCardClick = (action: string) => {
  router.push(action)
}
</script>

<template>
  <ActionCard
    :icon="NotebookPenIcon"
    :title="t('rounds.rounds_to_complete', { count: roundsWithMissingAssignments?.count })"
    :subtitle="t('rounds.rounds_to_complete_subtitle')"
    :badge="{ title: t('documents.todo'), type: 'warning' }"
    button-action="/rounds/overview"
    :button-label="t('global.complete')"
    :is-loading="isPending"
    :is-visible="!!(roundsWithMissingAssignments?.count && roundsWithMissingAssignments?.count > 0)"
    @click="handleCardClick"
  />
</template>
